import React, { useState } from "react";
import classes from "./ShifuPage.module.css";
import logo from "../assets/shifu_logo.png";
import world_icon from "../assets/world_icon.svg";
import arrow_icon from "../assets/arrow_icon.svg";
import searchIcon from "../assets/searchIcon.svg";
import boltIcon from "../assets/boltIcon.svg";
import chartIcon from "../assets/chartIcon.svg";
import dbIcon from "../assets/dbIcon.svg";
import targetIcon from "../assets/targetIcon.svg";
import clockIcon from "../assets/clockIcon.svg";
import usersIcon from "../assets/usersIcon.svg";
import trendDownIcon from "../assets/trendDownIcon.svg";
import chart_Icon from "../assets/chart_Icon.svg";
import walletIcon from "../assets/walletIcon.svg";
import precisionIcon from "../assets/precisionIcon.svg";
import speedIcon from "../assets/speedIcon.svg";
import privacyIcon from "../assets/privacyIcon.svg";
import shifu_avatar from "../assets/shifu_avatar.jpg";
import Shifu_Avatars from "../assets/Shifu_Avatars.png";
import Add_icons from "../assets/Add_icons.svg";
import close_icons from "../assets/close_icons.png";
import ShifuHeader from "../component/ShifuHeader";
import ShifuFooter from "../component/ShifuFooter";
import ShifuForm from "./ShifuForm";

const metrics = [
  {
    label: "SEARCH TIME",
    value: "90%",
    desc: "Reduction in content discovery time",
    icon: searchIcon,
    arrow: arrow_icon,
  },
  {
    label: "PROFICIENCY",
    value: "40%",
    desc: "Faster time-to-proficiency",
    icon: boltIcon,
    arrow: arrow_icon,
  },
  {
    label: "COMPLETION",
    value: "3x",
    desc: "Higher course completion rate",
    icon: chartIcon,
    arrow: arrow_icon,
  },
  {
    label: "ROI METRIC",
    value: "Clear",
    desc: "Cost per skill acquired visibility",
    icon: dbIcon,
    arrow: arrow_icon,
  },
];

const data = [
  {
    title: "Abundance Without Precision",
    desc: "Vast content libraries but employees can't find what's relevant",
    value: "85%",
    label: "dropout rate",
    icon: targetIcon,
  },
  {
    title: "Manual & Time-Consuming",
    desc: "L&D managers spend hours curating paths manually",
    value: "40hrs",
    label: "wasted monthly",
    icon: clockIcon,
  },
  {
    title: "One-Size-Fits-None",
    desc: "Generic paths ignore individual backgrounds and goals",
    value: "0%",
    label: "personalization",
    icon: usersIcon,
  },
  {
    title: "Low Engagement",
    desc: "Irrelevant content leads to massive abandonment",
    value: "12%",
    label: "completion rate",
    icon: trendDownIcon,
  },
  {
    title: "Unmeasurable ROI",
    desc: "Certificates don't prove actual skill acquisition",
    value: "$0",
    label: "proven value",
    icon: chart_Icon,
  },
  {
    title: "Budget Waste",
    desc: "Average enterprise wastes 40–60% of L&D spend",
    value: "50%",
    label: "wasted budget",
    icon: walletIcon,
  },
];

const cards = [
  {
    tag: "PRECISION",
    title: "ARCHITECTED N=1 ROADMAPS",
    desc: "Every path is unique. We cross-reference individual background with enterprise objectives to generate immediate learning steps.",
    icon: precisionIcon,
  },
  {
    tag: "SPEED",
    title: "ADAPTIVE CONTENT",
    desc: "Our engine indexes internal libraries (Udemy, LinkedIn, Coursera) to extract only the most relevant 4 minutes of a 4-hour course.",
    icon: speedIcon,
    active: true,
  },
  {
    tag: "PRIVACY",
    title: "JUDGMENT-FREE AI TUTORING",
    desc: "An always-on technical co-pilot allows learners to resolve doubts in real-time without organizational friction or exposure.",
    icon: privacyIcon,
  },
];

const faqData = [
  {
    id: "01",
    question:
      " How is Shifu different from just giving employees access to LinkedIn Learning or Udemy?",
    answer:
      "Those platforms give you a library; Shifu gives you a coach. An employee describes their goal and background in plain language, and Shifu builds a personalized roadmap using the best content from those same libraries. A Finance professional learning Python gets a completely different path than an Engineer learning the same thing — precision that a catalogue can never offer.",
  },
  {
    id: "02",
    question: "Does this replace our existing LMS or licensed content?",
    answer:
      "No — it works on top of what you already have. Shifu plugs into your existing libraries and LMS, surfaces the right content at the right time, and gets more value out of licenses you're already paying for. No new content purchases, no additional silos.",
  },
  {
    id: "03",
    question: "How much control do managers and L&D teams retain?",
    answer:
      "As much or as little as you want. Shifu offers three modes: fully AI-driven for large cohorts, a Co-Pilot mode where managers review and edit AI-generated plans, and an Expert-Led mode where your SMEs design the path and Shifu handles delivery. You can switch between modes as needs evolve.",
  },
  {
    id: "04",
    question:
      "How do we know employees are actually developing skills, not just completing modules?",
    answer:
      "Completion rates are a vanity metric — Shifu measures skill progression instead. Micro-assessments run throughout the journey to validate knowledge retention in real time, and learners build portfolio projects based on real industry tasks. You get demonstrable evidence of readiness, not just a certificate.",
  },
  {
    id: "05",
    question: "How long does it take to get started?",
    answer:
      "A pilot can be up and running with 1–2 cohorts within two weeks, with success criteria defined upfront. Individual learners go from first prompt to active learning in under 3 minutes. There's no lengthy implementation or migration required.",
  },
  {
    id: "06",
    question: "Is Shifu secure enough for enterprise use?",
    answer:
      "Yes. Shifu is SOC-2 ready, supports role-based access control, and is built to meet enterprise governance standards. Your organizational and employee learning data are fully protected",
  },
];

export default function ShifuPage() {
  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleCalendarOpen = () => {
    window.open("https://calendar.app.google/f8rR8BEaYL3ECTpa6", "_blank");
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.page}>
          <ShifuHeader />
          <div className={classes.inercontainer}>
            <section className={classes.hero}>
              {/* <div className={classes.pill}>
                • DEPLOYING N=1 PRECISION AT SCALE
              </div> */}

              <h1 className={classes.heading}>
                <span className={classes.dark}>MEASURABLE</span>
                <span className={classes.blue}>COGNITIVE</span>
                <span className={classes.dark}>VELOCITY.</span>
              </h1>

              <p className={classes.subtext}>
                Start engineering growth. Shifu translates organizational intent
                into <strong>personalized roadmaps</strong> that eliminate
                discovery friction.
              </p>

              <div className={classes.ctaRow}>
                <button
                  className={classes.primaryBtn}
                  onClick={handleCalendarOpen}
                >
                  INITIATE PILOT
                </button>{" "}
                <div className={classes.validate_button}>
                  <img src={world_icon} className={classes.validate_icon} />
                  {/* <span>VALIDATED BY BIG4 L&amp;D</span> */}
                  <span>Trusted by Leading Enterprises</span>
                </div>
              </div>
            </section>

            <section className={classes.metrics}>
              {metrics.map((m, i) => (
                <div key={i} className={classes.metricCards}>
                  <div className={classes.metricTop}>
                    <span className={classes.metricLabel}>{m.label}</span>
                    <img src={m.icon} className={classes.metricIcon} alt="" />
                  </div>

                  <div className={classes.metricValue}>
                    {m.value}
                    <img src={m.arrow} className={classes.arrowIcon} alt="" />
                  </div>

                  <p className={classes.metricDesc}>{m.desc}</p>
                </div>
              ))}
            </section>
          </div>
          <section id="whyShifu" className={classes.failSection}>
            <h2 className={classes.failHeading}>
              Why Traditional Training Fails
            </h2>

            <p className={classes.failSubHeading}>
              Despite billions in investment, enterprise learning delivers
              minimal measurable impact
            </p>

            <div className={classes.failGrid}>
              {data.map((item, index) => (
                <div key={index} className={classes.failCard}>
                  <div className={classes.failIcon}>
                    <img src={item.icon} alt="" />
                  </div>

                  <h3 className={classes.failTitle}>{item.title}</h3>
                  <p className={classes.failDesc}>{item.desc}</p>

                  <div className={classes.failStat}>
                    <span className={classes.failValue}>{item.value}</span>
                    <span className={classes.failLabel}>{item.label}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <div className={classes.halfcontainer}>
            <section id="howShifuWorks" className={classes.neural}>
              <div className={classes.neuralContainer}>
                {/* ================= HEADER ================= */}
                <div className={classes.neuralHeader}>
                  {/* LEFT CONTENT */}
                  <div className={classes.neuralLeft}>
                    <div className={classes.sectionKicker}>
                      <span className={classes.kickerLine}></span>
                      <span className={classes.kickerText}>
                        HOW SHIFU WORKS
                      </span>
                    </div>

                    <h2 className={classes.neuralTitle}>
                      PERSONALIZED LEARNING, <br />
                      AUTOMATED.
                    </h2>

                    <p className={classes.neuralSubtitle}>
                      Shifu removes the cognitive load of discovery by turning
                      vague intent into surgical technical schematics.
                    </p>
                  </div>

                  {/* RIGHT IMAGE */}
                  <div className={classes.imageConatiner7}>
                    <img
                      src={Shifu_Avatars}
                      alt="Shifu Avatars"
                      className={classes.shifu_avatars}
                    />
                  </div>
                </div>

                {/* ================= CARD GRID ================= */}
                <div className={classes.neuralGrid}>
                  {cards.map((item, index) => (
                    <div
                      key={index}
                      className={`${classes.neuralCard} ${
                        item.active ? classes.active : ""
                      }`}
                    >
                      <div className={classes.cardTop}>
                        <div className={classes.cardIcon}>
                          <img src={item.icon} alt={item.tag} />
                        </div>

                        <span className={classes.cardTag}>{item.tag}</span>
                      </div>

                      <h3 className={classes.cardTitle}>{item.title}</h3>

                      <p className={classes.cardDesc}>{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section id="caseStudy" className={classes.big4}>
              <div className={classes.big4Container}>
                <div className={classes.big4Left}>
                  <div className={classes.sectionKickers}>
                    <span className={classes.caseStudyBadge}>CASE STUDY</span>
                  </div>

                  <h2 className={classes.big4Title}>
                    {/* BIG4 <br /> VALIDATION */}
                    REAL RESULTS AT SCALE
                  </h2>

                  <p className={classes.big4Subtitle}>
                    {/* Pilot deployment across Tech, Tax & Risk Consulting proved
                    that intent-based personalization outperforms library search
                    by <span className={classes.big4Highlight}>90%</span> in
                    engagement metrics.  */}
                    A Big4 consulting firm deployed Shifu across their Tech,
                    Tax, and Risk teams. Within 15 days, personalized learning
                    paths drove 91% relevance scores and tripled course
                    completions.
                  </p>

                  <div className={classes.big4QuoteCard}>
                    <p className={classes.big4Quote}>
                      Shifu replaced weeks of manual curation. Now every
                      consultant gets a learning path tailored to their project,
                      their role, and their career goals - automatically.
                    </p>

                    <hr className={classes.big4Divider} />

                    <div className={classes.big4Author}>
                      <div className={classes.big4Avatar}>
                        <img
                          src={shifu_avatar}
                          alt=""
                          className={classes["shifu_avatar"]}
                        />
                      </div>
                      <div>
                        <span className={classes.big4AuthorName}>
                          L&D LEADERSHIP
                        </span>
                        <span className={classes.big4AuthorRole}>
                          Head of L&D, BIG4
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={classes.big4Right}>
                  <div className={classes.big4MetricLarge}>
                    <span className={classes.big4MetricLabel}>
                      METRIC: SKILLING RELEVANCE
                    </span>

                    <div className={classes.big4MetricValue}>
                      91<span className={classes.big4Percent}>%</span>
                    </div>

                    <div className={classes.big4Progress}>
                      <span style={{ width: "91%" }}></span>
                    </div>
                  </div>

                  <div className={classes.big4MetricGrid}>
                    <div className={classes.big4MetricSmall}>
                      <span className={classes.big4MetricLabel}>
                        DISCOVERY SAVINGS
                      </span>

                      <h3 className={classes.big4MetricValues}>90%</h3>

                      <p className={classes.big4MetricDesc}>SAVED PER MODULE</p>
                    </div>

                    <div className={classes.big4MetricSmall}>
                      <span className={classes.big4MetricLabel}>
                        TIME TO PROFICIENCY
                      </span>

                      <h3 className={classes.big4MetricValues}>-42%</h3>

                      <p className={classes.big4MetricDesc}>ACCELERATION</p>
                    </div>
                  </div>

                  {/* <button
                    className={classes.big4Cta}
                    onClick={() => setShowModal(true)}
                  >
                    <span className={classes.ctaText}>
                      GET THE IMPACT REPORT
                    </span>
                    <span className={classes.ctaArrow}>→</span>
                  </button> */}
                  {showModal && (
                    <div className={classes.modalOverlay}>
                      <div className={classes.modalContent}>
                        <button
                          className={classes.closeBtn}
                          onClick={() => setShowModal(false)}
                        >
                          ✕
                        </button>
                        <ShifuForm onClose={() => setShowModal(false)} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>

            <section className={classes["hero-wrapper"]}>
              <div className={classes["hero-card"]}>
                <h1 className={classes["hero-heading"]}>
                  ARCHITECT YOUR <br />
                  <span className={classes["hero-highlight"]}>
                    FUTURE WORKFORCE.
                  </span>
                </h1>

                <p className={classes["hero-description"]}>
                  Launch a 14-day precision pilot with your highest-priority
                  cohort. Shifu establishes baseline KPIs before the first
                  roadmap is generated.
                </p>

                <div className={classes["hero-actions"]}>
                  <button
                    className={classes["btn-primary"]}
                    onClick={() => setShowModal(true)}
                  >
                    APPLY FOR BETA ACCESS
                  </button>

                  <button
                    className={classes["btn-secondary"]}
                    onClick={() => setShowModal(true)}
                  >
                    SCHEDULE DEMO
                  </button>
                </div>
              </div>
            </section>

            <div className={classes.faqSection}>
              <h2 className={classes.faqheading}>FAQs</h2>

              <div className={classes.faqcontainer}>
                {faqData.map((item, index) => (
                  <div key={index} className={classes.card}>
                    <div
                      className={classes.cardHeader}
                      onClick={() => toggleFaq(index)}
                    >
                      <div className={classes.left}>
                        <span className={classes.number}>
                          {item.id.split("").map((digit, i) => (
                            <span
                              key={i}
                              className={
                                i === 0
                                  ? classes.firstDigit
                                  : classes.secondDigit
                              }
                            >
                              {digit}
                            </span>
                          ))}
                        </span>
                        <p className={classes.question}>{item.question}</p>
                      </div>

                      <div className={classes.icon}>
                        <img
                          src={activeIndex === index ? close_icons : Add_icons}
                          alt="toggle icon"
                          className={classes.iconImage}
                        />
                      </div>
                    </div>

                    <div
                      className={`${classes.answerWrapper} ${
                        activeIndex === index ? classes.show : ""
                      }`}
                    >
                      <p className={classes.answer}>{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <ShifuFooter />
        </div>
      </div>
    </div>
  );
}
